<template>
  <v-card flat :style="`height: ${ windowSize.y }px; position: 'relative'`" class="pa-1 product-view" v-resize="onResizeHandler">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pa-0">
      <v-form ref="pickForm" v-on:submit.prevent>
        <v-row>
          <v-col cols="12" class="pa-0 pl-3 font-weight-bold">
            {{ $t('message.ccsheet.warehouse') }}: {{ sheetModel.warehousename }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="7" class="pt-0 pr-0 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scannedLocation" flat autocomplete="off" :disabled="lockLocation"
              ref="scanLocation" @change="checkLocationAlreadyCounted" :loading="loadingLocation"
            :placeholder="$t('message.ccsheet.scanLocation')"></v-text-field>
          </v-col>
          <v-col cols="5" class="pa-0 pr-3 mt-1 text-right">
            <v-btn color="primary" tabindex="-1" @click="scanNextLocation">{{ $t('message.ccsheet.nextLoc') }}</v-btn>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scanProduct" flat autocomplete="off"
              ref="scanProduct" id="scanProduct" @click="selectContent" @focusout="checkQtyChanged" @change="getRespectiveProduct(0)"
              :loading="loadingProduct" @keydown.tab.prevent="() => false"
            :placeholder="$t('message.order.scanProduct')"></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-1 pb-1 font-weight-bold" v-if="sheetItemFound">
            {{ scannedSheetItem.productname || '' }}
          </v-col>
          <template v-if="sheetItemFound && scannedSheetItem.producthasbatch">
            <v-col cols="8" class="pt-0 pr-0 pb-0">
              <v-text-field outlined dense hide-details v-model="selectBatch" flat autocomplete="off"
              @change="checkForValidBatchNumber" :loading="loadingBatch"
              :rules="$_requiredValidation" :placeholder="$t('message.product.batch')" ref="batchRef"></v-text-field>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="sheetItemFound">
          <v-col cols="9" class="pa-1">
            <v-row>
              <v-col cols="8" class="pa-0 pl-2">
                <v-text-field outlined dense hide-details type="number" class="text-right" v-model="pickQty"
                  autocomplete="off" ref="qtyRef" :rules="pickQty ? $_zeroValidation : []" :placeholder="$t('message.product.qty')"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3" class="pa-1 mt-1">
            <v-btn color="primary" dark small :loading="saveLoading" @click="saveCountedProduct(true)">
              {{ $t('message.ccsheet.count') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-text class="highlight pt-0 pb-0 pl-1 pr-1 mt-2">
      <v-row>
        <v-col cols="4" class="pa-0 pl-1 font-weight-bold">{{ $t('message.dashboard.product') }}</v-col>
        <v-col cols="3" class="pa-0 pl-1 text-center font-weight-bold">{{ $t('message.order.location') }}</v-col>
        <v-col cols="1" class="pa-0 text-right font-weight-bold">{{ $t('message.ccsheet.unit') }}</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold">{{ $t('message.ccsheet.stock') }}</v-col>
        <v-col cols="2" class="pa-0 text-right font-weight-bold smaller-font">{{ $t('message.ccsheet.counted') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <div style="height: 350px;overflow-y: auto;position: relative;" id="infinite-list">
        <template v-for="(product, index) in listOfProducts">
          <v-row :key="`${index}_product`" class="pt-1 pb-1" @click="updateCCSheetItem(product)">
            <v-col cols="4" class="pa-0 pl-1 text-truncate bigger-font" :title="product.productnumber" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
              {{ product.productnumber }}
            </v-col>
            <v-col cols="3" class="pa-0 text-center text-truncate" :title="product.locationname">{{ product.locationname }}</v-col>
            <v-col cols="1" class="pa-0 text-right text-truncate smaller-font" :title="product.productunit">{{ product.productunit }}</v-col>
            <v-col cols="2" class="pa-0 text-right text-truncate" :title="product.onstock">{{ product.onstock | absoluteNumber }}</v-col>
            <v-col cols="2" class="pa-0 pl-1 text-right text-truncate" :title="product.counted">
              {{ product.counted | absoluteNumber }}
            </v-col>
          </v-row>
          <v-row :key="`${index}_name`">
            <v-col cols="10" class="pa-0 pl-1 text-truncate smaller-font">{{ product.productname }}</v-col>
            <v-col cols="2" class="pa-0 text-right text-truncate">{{ product.batchnumber }}</v-col>
            <v-col cols="12" class="pa-0 pt-1">
              <v-divider class="pa-0"></v-divider>
            </v-col>
          </v-row>
        </template>
      </div>
    </v-card-text>
    <!-- <v-pagination v-model="activePage" :length="totalLength" circle :total-visible="5"></v-pagination> -->
    <!-- <v-fab-transition>
      <v-btn bottom left color="primary" id="scroll__top" class="mt-2" tabindex="-1" fixed @click="completeCountingHandler">
         {{ $t('message.ccsheet.closeComplete') }}
      </v-btn>
    </v-fab-transition> -->
    <!-- Show warning when the product is counted already in a location! -->
    <!-- <v-dialog v-model="showWarning" persistent class="mt-0">
      <v-card>
        <v-card-title class="pa-2">
          {{ $t('message.ccsheet.info') }}
          <v-spacer></v-spacer>
          <v-btn color="error" icon id="warningClose" fab small @click="showWarning=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2">
          <h4>{{ $t('message.ccsheet.stockTake') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="info" small id="continueCounting" @click="continueCoutingHandler">{{ $t('message.ccsheet.continueCount') }}</v-btn>
          <v-btn color="success" small id="clearCounting" @click="clearAndRecountHandler">{{ $t('message.ccsheet.clearAndRecount') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="completeDialog" persistent class="mt-0">
      <v-card>
        <v-card-title class="pa-2">
          {{ $t('message.ccsheet.info') }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2">
          <h4>{{ $t('message.ccsheet.ccsheetComplete') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" small :loading="completeLoading" @click="completeSheetItems">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="success" small @click="completeDialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      listOfProducts: [],
      loading: false,
      windowSize: {
        x: 0,
        y: 0
      },
      saveLoading: false,
      completeLoading: false,
      loadingBatch: false,
      sheetModel: {},
      scanProduct: '',
      scannedLocation: '',
      selectBatch: '',
      scannedSheetItem: {},
      sheetItemFound: false,
      pickQty: '',
      sheetId: 0,
      showWarning: false,
      lockLocation: false,
      isContinueCounting: 1,
      isClearAndCount: 0,
      completeDialog: false,
      loadingLocation: false,
      loadingProduct: false,
      productUnits: [],
      activePage: 1,
      totalLength: 0,
      scannedDiffProduct: false,
      previousScannedItem: {},
      isFirstFocusout: false,
      isRecordEdited: false
    }
  },
  mounted () {
    this.sheetId = this.$route.params.sheet_id
    this.getProductUnits()
    this.getCountedProducts()
    this.getListOfProducts()
    this.focusField('scanLocation')
    const listElm = document.querySelector('#infinite-list')
    listElm.addEventListener('scroll', e => {
      if (!this.reachedBottom && this.totalLength !== this.listOfProducts.length) {
        if ((listElm.scrollTop + 1) + listElm.clientHeight >= listElm.scrollHeight) {
          this.getListOfProducts()
          this.reachedBottom = true
        }
      }
    })
  },
  methods: {
    checkLocationAlreadyCounted () {
      let getProducts = this.sheetModel.stocks
      if (getProducts) {
        this.loadingLocation = true
        let checkLoc = getProducts.find(x => x.locationname === this.scannedLocation)
        if (checkLoc) {
          // let getLoc = getProducts.filter(x => x.locationname === this.scannedLocation && x.counted > 0)
          // if (getLoc && getLoc.length > 0) {
          //   this.showWarning = true
          // } else {
          this.focusField('scanProduct')
          this.lockLocation = true
          // }
        } else {
          let location = this.listOfLocations.find(x => x.name === this.scannedLocation)
          if (!location) {
            this.focusField('scanLocation')
            this.lockLocation = false
            this.scannedLocation = ''
            this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noLocFound') })
          } else {
            this.lockLocation = true
          }
        }
        this.loadingLocation = false
      }
    },
    isDifferentProduct () {
      if (this.scannedSheetItem.productid) {
        this.increaseQty()
      }
    },
    checkQtyChanged () {
      // calls on focusout
      if (!this.isRecordEdited) {
        if (!this.isFirstFocusout && this.pickQty > 0) {
          this.pickQty--
          this.isFirstFocusout = true
        }
      }
    },
    async updateCCSheetItem ({ productnumber, counted, locationname, batchnumber }) {
      this.scannedLocation = locationname
      this.scanProduct = productnumber
      this.selectBatch = batchnumber
      // this.isContinueCounting = 0
      let countedVal = counted - 1 // since we autocount by one in the getRespectiveProduct(), that's why minus one
      await this.getRespectiveProduct(countedVal)
      this.isRecordEdited = true
      this.isContinueCounting = 0
    },
    async getRespectiveProduct (setPickedQty = 0) {
      if (this.scanProduct) {
        this.loadingProduct = true
        let ccsheetItems = this.$format.cloneVariable(this.sheetModel.stocks)
        let location = this.listOfLocations.find(x => x.name === this.scannedLocation)
        if (ccsheetItems && location) {
          this.scanProduct = this.scanProduct.trim()
          let scanedLower = this.scanProduct.toLowerCase()
          let sheetItem = ccsheetItems.find(x => ((x.productbarcode || '').toLowerCase() === scanedLower || (x.productnumber || '').toLowerCase() === scanedLower || (x.productnumberbarcode || '').toLowerCase() === scanedLower) && x.locationid === location.id)
          if (sheetItem && sheetItem.producthasbatch) {
            sheetItem = ccsheetItems.find(x => ((x.productbarcode || '').toLowerCase() === scanedLower || (x.productnumber || '').toLowerCase() === scanedLower || (x.productnumberbarcode || '').toLowerCase() === scanedLower) && x.locationid === location.id &&
              x.batchnumber === this.selectBatch)
          }
          // if scanned product found!
          if (sheetItem) {
            if (this.previousScannedItem.id && this.previousScannedItem.id !== sheetItem.id) {
              this.isFirstFocusout = false
              await this.saveCountedProduct()
              this.pickQty = setPickedQty
            }
            if (!this.previousScannedItem.productid && setPickedQty && setPickedQty > 0) {
              this.pickQty = setPickedQty
            }
            let existingItem = this.$format.cloneVariable(sheetItem)
            existingItem.batchrequired = existingItem.producthasbatch
            this.scannedSheetItem = existingItem
            this.sheetItemFound = true
            this.previousScannedItem = this.$format.cloneVariable(existingItem)
            this.isDifferentProduct()
          } else {
            // if scanned product not found!
            const filterByProductGroup = this.sheetModel.productgroupids ? JSON.parse(this.sheetModel.productgroupids) : []
            const pGroupIds = filterByProductGroup && filterByProductGroup.length > 0 ? filterByProductGroup : []
            var filter = []
            if (pGroupIds && pGroupIds.length > 0) {
              pGroupIds.map((x, i) => {
                const id = x.id ? x.id : x
                if (i === 0) filter.push(`productgroupid eq '${id}'`)
                else filter.push(`OR productgroupid eq '${id}'`)
              })
              filter = filter.join(' ')
            }
            let query = {
              filter: `number contains '${this.scanProduct}' OR barcode contains '${this.scanProduct}' OR name contains '${this.scanProduct}'`,
              additionalfilters: filter && filter.length > 0 ? [filter] : '',
              'skip': 0,
              'limit': 50,
              'order_by': {
                'field': 'number',
                'asc_or_desc': 'desc'
              }
            }
            this.$api.execute('post', 'products/query', query).then(async (response) => {
              if (response.data) {
                response.data = response.data.filter(x => !x.notinventoryitem && !x.isdeleted)
                if (response.data.length > 0) {
                  const newProduct = response.data[0]
                  this.scannedSheetItem = {}
                  this.sheetItemFound = false
                  if (this.previousScannedItem.productid && response.data[0].id !== this.previousScannedItem.productid) {
                    this.isFirstFocusout = false
                    await this.saveCountedProduct()
                    this.pickQty = setPickedQty
                  }
                  this.sheetItemFound = true
                  newProduct.productid = newProduct.id
                  newProduct.id = 0 // after setting productid make it 0 for sheetitemid
                  newProduct.ccsheetid = this.sheetId
                  newProduct.locationid = location.id
                  newProduct.productname = newProduct.name
                  newProduct.producthasbatch = newProduct.batchrequired
                  newProduct.productbarcode = newProduct.barcode
                  this.scannedSheetItem = newProduct
                  this.previousScannedItem = this.$format.cloneVariable(newProduct)
                  this.isDifferentProduct()
                } else {
                  await this.noProductFoundHandler()
                }
              }
            })
          }
        }
        this.loadingProduct = false
      } else {
        await this.noProductFoundHandler()
      }
    },
    async noProductFoundHandler () {
      if (this.previousScannedItem.id) {
        this.sheetItemFound = true
      }
      if (this.previousScannedItem.productid) {
        this.isFirstFocusout = false
        await this.saveCountedProduct()
        this.pickQty = 0
      }
      var noProductSound = new Audio(require('@/../public/audio/alter_no_barcode.mp3'))
      noProductSound.play()
      this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noProductFound') })
      this.focusField('scanProduct')
      this.scanProduct = ''
      this.pickQty = ''
      this.selectBatch = ''
      this.countNextHandler(true)
    },
    getStockValueFromLocationHandler (productid, locationid, batch) {
      if (this.sheetModel.warehouseid && productid && locationid) {
        return new Promise((resolve, reject) => {
          this.$api.execute('get', `/stocks/get_product_by_warehouse_and_location?product_id=${productid}&warehouse_id=${this.sheetModel.warehouseid}&locationid=${locationid}`)
            .then((result) => {
              let model = result.data
              model = model.filter(x => x.on_stock > 0)
              if (batch) {
                model = model.filter(x => x.batchnumber === batch)
                if (model && model.length === 1) {
                  resolve({ locationid: model[0].locationid, onstockVal: model[0].on_stock })
                } else {
                  resolve(0)
                }
              } else {
                if (model && model.length === 1) {
                  resolve({ locationid: model[0].locationid, onstockVal: model[0].on_stock })
                } else {
                  resolve(0)
                }
              }
            })
            .catch((err) => {
              console.log(err)
              reject(err)
            })
        })
      } else return Promise.resolve()
    },
    async addNewProduct (counted, isManualUpdate) {
      let itemFoundObj = null
      let foundLocationname = null
      if (this.sheetModel.stocks) {
        itemFoundObj = this.sheetModel.stocks.find(x => x.locationname === this.scannedLocation)
        if (!itemFoundObj) {
          itemFoundObj = this.listOfLocations.find(x => x.name === this.scannedLocation)
          if (itemFoundObj) {
            itemFoundObj.locationid = itemFoundObj.id
            foundLocationname = itemFoundObj.name
          }
        } else {
          foundLocationname = itemFoundObj.locationname
        }
      }
      var scannedProduct = this.$format.cloneVariable(this.previousScannedItem)
      if (itemFoundObj && itemFoundObj.locationid) {
        const { onstockVal } = await this.getStockValueFromLocationHandler(scannedProduct.productid, itemFoundObj.locationid, '')
        let model = {
          ccsheetid: this.sheetId,
          locationid: itemFoundObj.locationid,
          productid: scannedProduct.productid,
          batchnumber: '',
          onstock: onstockVal,
          counted: counted,
          salesprice: scannedProduct.costprice,
          locationname: foundLocationname
        }
        if (scannedProduct && scannedProduct.producthasbatch) {
          if (this.selectBatch) {
            model.batchnumber = this.selectBatch
            await this.saveNewProductHandler(model, scannedProduct, isManualUpdate)
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
          }
        } else {
          await this.saveNewProductHandler(model, scannedProduct, isManualUpdate)
        }
      }
    },
    saveNewProductHandler (model, scanedProduct, isManualUpdate) {
      return new Promise((resolve, reject) => {
        this.$api.execute('post', 'ccsheetitems', model).then(response => {
          if (response && response.data) {
            model.id = response.data.id
            if (scanedProduct.name) {
              model.productname = scanedProduct.name
              model.productnumber = scanedProduct.number
              model.productunit = scanedProduct.productunit
              model.producthasbatch = scanedProduct.batchrequired
              model.productbarcode = scanedProduct.barcode
              if (scanedProduct.unitid) {
                let productUnitObj = this.productUnits.find(x => x.id === scanedProduct.unitid)
                if (productUnitObj) {
                  model.productunit = productUnitObj.name
                }
              }
            } else if (scanedProduct.productname) {
              model.productname = scanedProduct.productname
              model.productnumber = scanedProduct.productnumber
              model.productunit = scanedProduct.productunit
              model.producthasbatch = scanedProduct.producthasbatch
              model.productbarcode = scanedProduct.productbarcode
            }
            this.sheetModel.stocks.unshift(model)
            this.listOfProducts.unshift(model)

            // this.getCountedProducts()
            // this.scanProduct = ''
            // this.pickQty = ''
            this.selectBatch = ''
            // this.scannedSheetItem = {}
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.addedSucess') })
            resolve()
          } else {
            resolve()
          }
          this.saveLoading = false
          this.isContinueCounting = 1
          this.countNextHandler(isManualUpdate)
          this.focusField('scanLocation')
          // this.getCountedProducts()
        })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getCountedProducts () {
      this.loading = true
      this.$api.execute('get', `ccsheets/get_ccsheet/${this.sheetId}`)
        .then((response) => {
          if (response.data) {
            this.sheetModel = response.data
            this.getWarehouseLocations()
              .then(() => {
                this.loading = false
              })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getListOfProducts () {
      setTimeout(() => {
        this.loading = true
        let totalDisplay = 10
        let queryModel = {
          ccsheetid: this.sheetId,
          page: this.activePage++,
          decending: true,
          sortby: 'id',
          rowsperpage: totalDisplay
        }
        this.$api.execute('post', 'ccsheetitems/paginate_filter', queryModel)
          .then((response) => {
            let transformData = { number: { list: ['onstock', 'counted'], format: 'replaceDotWithCommaWOFixed' } }
            let resultedItems = response.data.items || []
            const list = this.listOfProducts
            list.push(...this.$format.formatListModel(resultedItems, transformData))
            this.listOfProducts = list
            this.totalLength = response.data.total
            this.loading = false
            this.reachedBottom = false
          })
          .catch(() => {
            this.loading = false
          })
      }, 200)
    },
    getProductUnits () {
      this.loading = true
      this.$api.execute('get', 'productunits')
        .then((response) => {
          if (response.data) {
            this.productUnits = response.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkForValidBatchNumber () {
      this.loadingBatch = true
      let products = this.$format.cloneVariable(this.sheetModel.stocks)
      let found = products.find(x => x.productid === this.scannedSheetItem.productid && x.locationname === this.scannedLocation && x.batchnumber === this.selectBatch)
      if (found) {
        this.scannedSheetItem = found
      } else {
        // if (this.foundProduct && this.foundProduct.batchrequired) {
        //   setTimeout(() => {
        //     this.focusField('qtyRef')
        //   })
        // } else {
        //   this.selectBatch = ''
        //   this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.notValidBatch') })
        //   setTimeout(() => {
        //     this.focusField('batchRef')
        //   })
        // }
      }
      this.loadingBatch = false
    },
    async saveCountedProduct (isManualUpdate = false) {
      if (!this.$format.isNullOrEmpty(this.pickQty)) {
        let counted = this.$format.replaceCommaWithDot(this.pickQty)
        let ccsheetItems = this.$format.cloneVariable(this.sheetModel.stocks)
        const rowExists = ccsheetItems.find(x => this.previousScannedItem && x.id === this.previousScannedItem.id)
        if (!rowExists) {
          await this.addNewProduct(counted, isManualUpdate)
        } else {
          if (this.previousScannedItem.id) {
            this.saveLoading = true
            await this.saveCountedValueHandler(counted, isManualUpdate)
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.ccsheet.noProductOnLocation') })
            this.previousScannedItem = {}
          }
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    saveCountedValueHandler (counted, isManualUpdate) {
      if (counted) {
        return new Promise((resolve, reject) => {
          this.$api.execute('post', `/ccsheets/save_counted_pwa/${this.previousScannedItem.id}?count=${counted}&isContinueCouting=${this.isContinueCounting}`)
            .then(response => {
              if (response && response.data) {
                let objIndex = this.sheetModel.stocks.findIndex(x => x.id === this.previousScannedItem.id)
                let obj = this.sheetModel.stocks.find(x => x.id === this.previousScannedItem.id)
                obj.counted = response.data.counted
                this.$set(this.sheetModel.stocks, objIndex, obj)
                let productObjIndex = this.listOfProducts.findIndex(x => x.id === this.previousScannedItem.id)
                let productObj = this.listOfProducts.find(x => x.id === this.previousScannedItem.id)
                if (productObj) {
                  productObj.counted = response.data.counted
                  this.$set(this.listOfProducts, productObjIndex, productObj)
                }
              }
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
              this.saveLoading = false
              this.isContinueCounting = 1
              this.isRecordEdited = false
              this.countNextHandler(isManualUpdate)
              // this.focusField('scanLocation')
              // this.getCountedProducts()
              resolve()
            })
            .catch((err) => {
              reject(err)
            })
        })
      } else {
        return Promise.resolve()
      }
    },
    completeCountingHandler () {
      this.completeDialog = true
    },
    completeSheetItems () {
      this.completeLoading = true
      let model = { sheetid: this.sheetId, stocks: [] }
      let transformData = { number: { list: ['onstock', 'counted'], format: 'replaceCommaWithDot' } }
      model.stocks = this.$format.formatListModel(this.sheetModel.stocks, transformData)
      this.$api.execute('post', `ccsheets/complete_ccsheet`, model)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          this.$router.push('/cycle_count')
        })
        .finally(() => {
          this.completeDialog = false
          this.completeLoading = false
        })
    },
    selectContent () {
      if (this.$refs.scanProduct) {
        setTimeout(() => {
          if (document.getElementById('scanProduct')) document.getElementById('scanProduct').select()
        }, 50)
      }
    },
    scanNextLocation () {
      this.scannedLocation = ''
      this.lockLocation = false
      this.focusField('scanLocation')
    },
    countNextHandler (isManualUpdate) {
      if (isManualUpdate) {
        this.selectBatch = ''
        this.sheetItemFound = false
        this.scanProduct = ''
        this.scannedSheetItem = {}
        this.previousScannedItem = {}
        this.pickQty = 0
        this.focusField('scanProduct')
      }
    },
    continueCoutingHandler () {
      this.isContinueCounting = 1
      this.isClearAndCount = 0
      this.showWarning = false
      this.lockLocation = true
    },
    clearAndRecountHandler () {
      this.isContinueCounting = 0
      this.isClearAndCount = 1
      this.showWarning = false
      this.lockLocation = true
    },
    onResizeHandler () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 40 }
    },
    focusField (value) {
      requestAnimationFrame(() => {
        if (this.$refs[value]) {
          this.$refs[value].focus()
        }
      })
    },
    decreaseQty () {
      if (this.pickQty > 0) this.pickQty--
    },
    increaseQty () {
      if (this.pickQty < 0) this.pickQty = ''
      this.pickQty++
      setTimeout(() => {
        this.selectContent()
        setTimeout(() => {
          this.focusField('scanProduct')
        }, 200)
      }, 200)
    },
    clearPickedQty () {
      this.pickQty = ''
    },
    getWarehouseLocations () {
      let model = {
        'filter': `isactive eq 1 AND warehouseid eq ${this.sheetModel.warehouseid}`,
        'order_by': {
          'field': 'name',
          'asc_or_desc': 'asc'
        }
      }
      return this.$api.execute('post', 'warehouselocations/query', model)
        .then((response) => {
          this.listOfLocations = response.data
        })
    }
  },
  async beforeRouteLeave (to, from, next) {
    if (this.pickQty) {
      await this.saveCountedProduct()
      next()
    }
    next()
  }
}
</script>
